import { __read } from "tslib";
import { launchUrl } from '@office-start/launcher-service';
import { useTeachingUiEnabled } from '@office-start/teaching-ui-config-service';
import { useUpdateHarmonyTheme } from '@office-start/visual-data-service';
import { useEffect, useMemo } from 'react';
import { useTuiServiceStore } from '../store';
import { useSingletonFirstLoadSetup } from './useSingletonFirstLoadSetup';
export var useTuiState = function (userProfileService) {
    var enabled = useTeachingUiEnabled();
    var _a = __read(useSingletonFirstLoadSetup(), 2), setupCompleted = _a[0], setUserProfileService = _a[1];
    useEffect(function () {
        if (!setupCompleted) {
            setUserProfileService(userProfileService);
        }
    }, [userProfileService, setUserProfileService, setupCompleted]);
    var _b = useTuiServiceStore(function (state) { return ({
        activeSequence: state.activeSequence,
        elementMap: state.elementMap,
        disabled: state.disabled,
    }); }), elementMap = _b.elementMap, activeSequence = _b.activeSequence, disabled = _b.disabled;
    var updateHarmonyTheme = useUpdateHarmonyTheme();
    var customActionProps = useMemo(function () {
        var customActions = {
            navigateUrl: function (url, launchUrlParams, launchInstrumentationParams, officeRouteParams) {
                launchUrl(url, launchUrlParams, launchInstrumentationParams, officeRouteParams);
            },
            updateHarmonyTheme: updateHarmonyTheme,
        };
        return customActions;
    }, [updateHarmonyTheme]);
    return useMemo(function () { return ({
        elementMap: elementMap,
        activeSequence: enabled ? activeSequence : undefined,
        disabled: disabled,
        customActionProps: customActionProps,
        setupCompleted: setupCompleted,
    }); }, [
        enabled,
        elementMap,
        activeSequence,
        customActionProps,
        disabled,
        setupCompleted,
    ]);
};
//# sourceMappingURL=useTuiState.js.map